import { defineFcm } from '../shared/factory';

export const FCM_ENABLE_PETITION_STRENGTH_TIPS = defineFcm('enable_petition_strength_tips')
	.asBoolean()
	.withDefault(false)
	.toConfig();
